import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { carouselImages } from "../../data/carousel";

export const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 900,
    autoplay: true,
    autoplaySpeed: 4500,
    fade: true,
    arrows: false,
    cssEase: "ease-in-out",
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        "& .slick-slide > div": { lineHeight: 0 },
        "& .slick-dots": { bottom: 24 },
        "& .slick-dots li button:before": { color: "#fff", fontSize: 8, opacity: 0.6 },
        "& .slick-dots li.slick-active button:before": { color: "#fff", opacity: 1 },
      }}
    >
      <Slider {...settings}>
        {carouselImages.map((caro, index) => (
          <Box key={index} sx={{ position: "relative" }}>
            <Box
              component="img"
              src={caro.img}
              alt={caro.title}
              sx={{ width: "100%", height: { xs: "100svh", md: "100vh" }, objectFit: "cover", display: "block" }}
            />
            {/* Gradient overlay */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.52) 100%)",
              }}
            />
            {/* Centered text + CTA */}
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                width: "90%",
                pointerEvents: "none",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "52px", sm: "84px", md: "140px" },
                  fontWeight: 300,
                  letterSpacing: "-0.04em",
                  lineHeight: 1,
                  color: "#fff",
                  textTransform: "uppercase",
                }}
              >
                {caro.title}
              </Typography>
              <Box sx={{ pointerEvents: "auto" }}>
                <Box
                  component={Link}
                  to={caro.path}
                  sx={{
                    display: "inline-block",
                    mt: { xs: 3, md: 5 },
                    px: { xs: 3.5, md: 5 },
                    py: { xs: 1.25, md: 1.75 },
                    border: "1px solid rgba(255,255,255,0.8)",
                    color: "#fff",
                    fontSize: { xs: 10, md: 11 },
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    fontWeight: 400,
                    transition: "background 0.25s, border-color 0.25s",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.14)", borderColor: "#fff" },
                  }}
                >
                  {caro.label}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};
